// src/App.js
import { Routes, Route } from 'react-router-dom';

import AdminLayout from './components/Layout/AdminLayout';

import Dashboard from './pages/Dashboard';
import CalendarPage from './pages/Calendar';
import AddVehicle from './pages/AddVehicle';
import Vehicles from './pages/Vehicles';
import Settings from './pages/Settings';
import EditDriver from './pages/EditDriver';
import AddDriver from './pages/AddDriver';
import Drivers from './pages/Drivers';
import EditVehicle from './pages/EditVehicle';
import AddHireAgreement from './pages/AddHireAgreement';
import HireAgreementsPage from './pages/HireAgreements';
import EditHireAgreement from './pages/EditHireAgreement';

export default function AdminApp() {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/vehicles/:id" element={<EditVehicle />} />
        <Route path="/vehicles/new" element={<AddVehicle />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/hire-agreements/:id" element={<EditHireAgreement />} />
        <Route path="/hire-agreements/new" element={<AddHireAgreement />} />
        <Route path="/hire-agreements" element={<HireAgreementsPage />} /> 
        <Route path="/settings" element={<Settings />} />
        <Route path="/drivers/:id" element={<EditDriver />} />
        <Route path="/drivers/new" element={<AddDriver />} />
        <Route path="/drivers" element={<Drivers />} />
      </Routes>
    </AdminLayout>
  );
}
